import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconUserCheck = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 28.875 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M28.675,8.579 L23.726,15.579 C23.557,15.818 23.292,15.971 23.001,15.996 L22.915,16.000 C22.654,16.000 22.401,15.897 22.214,15.711 L19.198,12.710 C18.807,12.322 18.804,11.689 19.191,11.296 C19.577,10.904 20.208,10.900 20.599,11.290 L22.782,13.460 L27.052,7.421 C27.371,6.971 27.992,6.866 28.440,7.184 C28.888,7.504 28.994,8.129 28.675,8.579 ZM12.753,13.400 C16.832,14.570 19.898,18.186 19.898,22.334 L19.898,23.000 C19.898,23.552 19.453,24.000 18.903,24.000 L0.981,24.000 C0.431,24.000 -0.015,23.552 -0.015,23.000 L-0.015,22.334 C-0.015,18.186 3.052,14.570 7.131,13.400 C4.685,12.312 2.972,9.855 2.972,7.000 C2.972,3.140 6.099,0.000 9.942,0.000 C13.785,0.000 16.912,3.140 16.912,7.000 C16.912,9.855 15.199,12.312 12.753,13.400 ZM1.985,22.000 L17.898,22.000 C17.702,18.173 14.138,15.000 9.942,15.000 C5.746,15.000 2.182,18.173 1.985,22.000 ZM9.942,2.000 C7.197,2.000 4.964,4.243 4.964,7.000 C4.964,9.757 7.197,12.000 9.942,12.000 C12.687,12.000 14.920,9.757 14.920,7.000 C14.920,4.243 12.687,2.000 9.942,2.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconUserCheck.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
